// extracted by mini-css-extract-plugin
export default {"heading_container":"homeProjects_heading_container__EHYgI","heading":"homeProjects_heading__z4O37"};